import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Contact() {
  return <section className="py-16 border-b border-gray-800" data-id="element-87">
      <div className="max-w-6xl mx-auto" data-id="element-88">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 flex items-center gap-3" data-id="element-89">
          <ShieldIcon className="w-7 h-7 md:w-8 md:h-8 text-orange-500" data-id="element-90" />
          Contact
        </h2>
        <p className="text-gray-300" data-id="element-91">
          Contact sectie wordt binnenkort toegevoegd.
        </p>
      </div>
    </section>;
}